import { RefObject, useEffect, useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import usePendingLocation from './usePendingLocation';

let firstRender = true;

if (typeof window !== 'undefined' && window.history.scrollRestoration !== 'manual') {
  window.history.scrollRestoration = 'manual';
}

export function useScrollRestoration() {
  const positions = useRef<Map<string | undefined, number>>(new Map()).current;
  const location = useLocation();
  const pendingLocation = usePendingLocation();

  useEffect(() => {
    if (pendingLocation) {
      positions.set(location.key, window.scrollY);
    }
  }, [pendingLocation, location, positions]);

  if (typeof window !== 'undefined') {
    // eslint-disable-next-line
    useLayoutEffect(() => {
      if (firstRender) {
        firstRender = false;
        return;
      }

      const y = positions.get(location.key);
      window.scrollTo(0, y || 0);
    }, [location, positions]);
  }
}

export function useElementScrollRestoration(ref: RefObject<HTMLElement>) {
  const positions = useRef<Map<string | undefined, number>>(new Map()).current;
  const location = useLocation();
  const pendingLocation = usePendingLocation();

  useEffect(() => {
    if (!ref.current) return;
    if (pendingLocation) {
      positions.set(location.key, ref.current.scrollTop);
    }
  }, [pendingLocation, location]); // eslint-disable-line

  if (typeof window !== 'undefined') {
    // eslint-disable-next-line
    useLayoutEffect(() => {
      if (!ref.current) return;
      const y = positions.get(location.key);
      ref.current.scrollTo(0, y || 0);
    }, [location]); // eslint-disable-line
  }
}
